import React from 'react';

function ItineraryLoader() {

    return (
        <div className="p-6 bg-gray-100 min-h-screen space-y-6">
            {/* Top card */}
            {/* <div className="bg-white p-4 rounded-lg shadow animate-pulse">
                <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-gray-300 rounded"></div>
                    <div className="flex-1">
                        <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
                        <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    </div>
                </div>
                <div className="mt-4 space-y-2">
                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                    <div className="h-4 bg-gray-300 rounded w-5/6"></div>
                    <div className="h-4 bg-gray-300 rounded w-2/3"></div>
                </div>
            </div> */}

            {/* Right side card */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="bg-white p-4 rounded-lg shadow animate-pulse lg:col-span-2">
                    <div className="flex items-center space-x-4 mb-4">
                        <div className="w-10 h-10 bg-gray-300 rounded"></div>
                        <div className="flex-1 space-y-2">
                            <div className="h-4 bg-gray-300 rounded w-3/5"></div>
                            <div className="h-4 bg-gray-300 rounded w-2/5"></div>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div className="h-32 bg-gray-300 rounded"></div>
                        <div className="h-32 bg-gray-300 rounded"></div>
                        <div className="h-32 bg-gray-300 rounded"></div>
                        <div className="h-32 bg-gray-300 rounded"></div>
                    </div>
                </div>

                <div className="bg-white p-4 rounded-lg shadow animate-pulse space-y-3">
                    <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                    <div className="h-4 bg-gray-300 rounded w-2/3"></div>
                </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="bg-white p-4 rounded-lg shadow animate-pulse lg:col-span-2">
                    <div className="flex items-center space-x-4 mb-4">
                        <div className="w-10 h-10 bg-gray-300 rounded"></div>
                        <div className="flex-1 space-y-2">
                            <div className="h-4 bg-gray-300 rounded w-3/5"></div>
                            <div className="h-4 bg-gray-300 rounded w-2/5"></div>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div className="h-32 bg-gray-300 rounded"></div>
                        <div className="h-32 bg-gray-300 rounded"></div>
                        <div className="h-32 bg-gray-300 rounded"></div>
                        <div className="h-32 bg-gray-300 rounded"></div>
                    </div>
                </div>

                <div className="bg-white p-4 rounded-lg shadow animate-pulse space-y-3">
                    <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                    <div className="h-4 bg-gray-300 rounded w-2/3"></div>
                </div>
            </div>

            {/* Bottom blocks */}
            <div className="bg-white h-12 rounded-lg shadow animate-pulse"></div>
            <div className="bg-white h-12 rounded-lg shadow animate-pulse"></div>
        </div>
    );
};

export default ItineraryLoader;